<style lang="less" scoped>
@keyframes heartbeat {

    0%,
    100% {
        transform: scale(1);
    }

    25% {
        transform: scale(1.1);
    }

    50% {
        transform: scale(0.95);
    }

    75% {
        transform: scale(1.05);
    }
}

div.wrapper {
    width: 100%;
    min-height: 100vh;
    background: #CAC2CE url("../../assets/images/promotion/bg.png") no-repeat;

    div.logo {
        display: flex;
        justify-content: start;
        align-items: center;
        padding-top: 50px;

        img {
            display: block;
            width: 102px;
            height: 102px;
            margin-right: 20px;
        }

        span.logo-text {
            font-size: 28px;
            color: #333;
        }
    }
}

div.content {
    position: relative;
    margin-top: 30px;

    div.amount {
        h2.amount-title {
            color: #151515;
            text-align: center;
            font-size: 48px;
        }

        p.amount-text {
            color: #7455BF;
            font-weight: 700;
            font-size: 100px;
            text-align: center;
            margin-top: 30px;
        }
    }

    div.content-pic {
        width: 590px;
        height: 538px;
        margin: 0 auto;

        img {
            width: 100%;
            height: 100%;
        }
    }

    div.content-button {
        width: 364px;
        height: 370px;
        position: absolute;
        top: 450px;
        left: 50%;
        transform: translateX(-50%);

        // transition: transform 0.2s ease-in-out;    
        img {
            animation: heartbeat 0.6s ease-in-out infinite;
            width: 100%;
            height: 100%;
        }
    }

    .form {
        width: 620px;
        margin: 100px auto 0 auto;

        .form-container {
            background: #fff;
            border-radius: 30px;
            padding: 10px 20px;

            .label {
                display: block;
                color: #66687D;
                font-size: 30px;
                margin: 50px 0 15px 0;
            }
        }

        .input-container {
            padding: 20px;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            // height: 0px;         
            .prefix {
                display: block;
                color: #FF7A55;
                font-size: 32px;
                height: 50px;
                line-height: 50px;
                padding: 0 20px 0 0;
                margin-right: 20px;
                ;
            }

            .input-content-container {
                flex: 1;

                // margin-left: 20px;
                input {
                    display: block;
                    width: 100%;
                    height: 100%;
                    border: none;
                    font-size: 32px;
                    background: transparent;
                    color: #333;

                    &::placeholder {
                        color: #CAC2CE;
                    }
                }
            }
        }
    }

    div.caption {
        padding: 40px;

        p.caption-text {
            font-size: 22px;
            color: #151515;
            line-height: 1.5;
            word-break: break-all;
            margin-bottom: 10px;
            strong{
                font-weight: 700;
            }
        }
    }
}

div.dialog-wrapper {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background:rgba(0,0,0,0.2);
    div.dialog {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        // width: 320px;
        // height: 220px;
        background: #fff;
        border-radius: 20px;

        div.dialog-content {
            p.dc-caption {
                font-size: 30px;
                color: #221826;
                text-align: center;
                font-weight: 700;
            }

            p.cout-donw-text {
                font-size: 24px;
                margin: 30px 0;
                text-align: center;
            }

            div.dialog-input-container {
                background: #F5F6FA;
                border-radius: 15px;
                padding: 15px;

                input {
                    display: block;
                    background: transparent;
                    width: 100%;
                    font-size: 28px;
                    color: #221826;
                    border:none;
                    text-align: center;
                }
            }
            .error{
                color:#f14747;
                font-size:24px;
                margin-top: 20px;
            }

            div.btn-group {
                width: 512px;
                margin:30px auto 0 auto;
                button.btn-submit {
                    width: 512px;
                    height: 80px;
                    background: #CEBBFB;
                    border-radius: 8px;
                    text-align: center;
                    font-size: 28px;
                    border:none;
                    color: #151515;                    
                }
            }
        }
    }
}
</style>
<template>    
    <div class="wrapper">
        <div class="dialog-wrapper" v-show="dialogShow">
            <div class="dialog">
                <div class="dialog-content">
                    <p class="dc-caption">
                        Fill in the OTP
                    </p>
                    <p class="cout-donw-text" v-text="code_text" @click="sendCodeFn"></p>
                    <div class="dialog-input-container">
                        <input type="tel" v-model="obj.code" @input="codeInput" placeholder="Please enter OTP"  @blur="iosBlur"/>
                    </div>
                    <div class="error" v-text="error_text" v-show="error_text.length > 0"></div>
                    <div class="btn-group">
                        <button class="btn-submit" @click="submit">Confirm</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="logo">
            <img src="../../assets/images/logo.png" alt="">
            <span class="logo-text">Credit Chakr</span>
        </div>
        <div class="content">
            <div class="amount">
                <h2 class="amount-title">
                    Max Amount
                </h2>
                <p class="amount-text">
                    ₹70000
                </p>
            </div>
            <div class="content-pic">
                <img src="../../assets/images/promotion/content-pic.png" alt="">
            </div>
            <div class="content-button" @click="sendCodeFn">
                <img src="../../assets/images/promotion/button.png" alt="">
            </div>
            <div class="form">
                <div class="form-container">
                    <div class="input-container">
                        <div class="prefix">+91</div>
                        <div class="input-content-container">
                            <input type="tel" v-model="obj.phone" placeholder="Enter your phone number here!" @blur="iosBlur"
                                @input="phoneInput">
                        </div>
                    </div>
                </div>
            </div>
            <div class="caption">
                <p class="caption-text">
                    <strong>1. Convenient Application, Fast Limit Inquiry</strong> <br>
                    Simply enter your phone number, click the "Get Limit" button, and instantly view your available credit limit.<br>
                </p>
                <p class="caption-text">
                    <strong>2. Security Assurance, Privacy Protection</strong><br>
                    We use strict encryption technology to ensure the security of your personal information and credit history.<br>
                </p>
                <p class="caption-text">
                    <strong>3. Based on Credit History, Instant Feedback</strong><br>
                    Your available credit limit is accurately calculated based on your past credit history, with results displayed instantly.<br>
                </p>
            </div>
        </div>
    </div>

</template>
<script>
import { reactive, ref, getCurrentInstance } from 'vue';
import { sendCode } from "@api/index"
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
export default {
    setup() {
        const router = useRouter()
        const store = useStore()
        const proxy  = getCurrentInstance().proxy
        const obj = reactive({
            "phone": "",
            "code": ""
        })
        const code_clicked = ref(false)
        const dialogShow = ref(false)
        let to = 0
        const code_text = ref("60s")
        const phoneInput = () => {
            if (/D+/.test(obj.phone) | obj.phone.length > 10) {
                obj.phone = obj.phone.substring(0, obj.phone.length - 1)
            }
        }
        const iosBlur = () => {
            setTimeout(() => {
                window.scrollTo(0, 0);  // 滚动回顶部，确保页面恢复正常布局
            }, 300);  
        }
        const sendCodeFn = async () => {
            if(obj.phone.length < 10) {
                proxy.$toast.show("Please Enter correct Phone Number")
                return 
            }
            if (code_clicked.value) return
            code_clicked.value = true
            let data = await sendCode({
                phone: "91" + obj.phone
            })
            if (data.code == 0) {
                dialogShow.value = true
                obj.secs = 60
                to = setInterval(() => {
                    code_text.value = `${--obj.secs}s`
                    if (obj.secs <= 0) {
                        clearInterval(to)
                        code_text.value = 'resend'
                        code_clicked.value = false
                    }
                }, 1000)
                // logEvent(analytics, 'register_send_sms')
            } else {
                code_clicked.value = false
                proxy.$toast.show(data.msg)                
            }

        }
        const codeInput = () => {
            if (/\D+/.test(obj.code) | obj.code.length > 4) {
                obj.code = obj.code.substring(0, obj.code.length - 1)
            }
        }
        const error_text = ref("")
        const submit = async () => {
            if(obj.clicked) return 
            if(obj.code == '') {
                error_text.value = "Please Enter Correct OTP"
                return 
            }
            obj.clicked = true            
            store.dispatch('login',{
                phone:obj.phone,
                code:obj.code
            }).then((resp)=>{
                // logEvent(analytics, 'register_logined')
                obj.clicked = false
                if(resp.isRegister == 1) {
                    // window.fbq('track', 'CompleteRegistration');
                }                
                
                router.replace({
                    path:'/promotion/amount'
                })                           
                
            }).catch((msg)=>{   
                obj.clicked = false                 
                error_text.value = msg
            })
            
        }
        return {
            obj,
            submit,
            sendCodeFn,
            phoneInput,
            codeInput,
            iosBlur,
            dialogShow,
            code_text,
            error_text
        }
    }
}

</script>